import React, { useEffect, useState } from 'react';
import { FormRegistro } from '../FormRegistro';
import { FormLogin } from '../FormLogin';
import { FormForgot } from '../FormForgot';
import { FormRecovery } from '../FormRecovery';
import { WrapperStyled } from './styles';
import { Snackbar, Alert } from '@mui/material';

const BoxIngreso = (props) => {

    const { open,
            setOpen,
            scope,
            setScope,
            trigger } = props;

    const [ showRegistro, setShowRegistro ] = useState(false);
    const [ showLogin, setShowLogin ] = useState(false);
    const [ showForgot, setShowForgot ] = useState(false);
    const [ showRecovery, setShowRecovery ] = useState(false);
    
    const [ openSnackbar, setOpenSnackbar ] = useState(false);
    const [ snackbarMessage, setSnackbarMessage] = useState("");
    const [ snackbarVariant, setSnackbarVariant] = useState("");
    
    const handleClose = () => {
        setOpenSnackbar(!openSnackbar);
    };

    useEffect(() => {
     
        if(scope === "login"){
            setShowLogin(true);
            setShowRecovery(false);
            setShowRegistro(false);
            setShowForgot(false);
        }
        if(scope === "registro"){
            setShowLogin(false);
            setShowRecovery(false);
            setShowRegistro(true);
            setShowForgot(false);
        }
        if(scope === "forgot"){
            setShowLogin(false);
            setShowRegistro(false);
            setShowRecovery(false);
            setShowForgot(true);
        }
        if(scope === "recovery"){
            setShowLogin(false);
            setShowRegistro(false);
            setShowForgot(false);
            setShowRecovery(true);
        }
    
      return () => {}
    }, [scope])
    
    
    return (
        <WrapperStyled>
            <Snackbar
                anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                open={openSnackbar}
                onClose={handleClose}
                message="I love snackssss"
                key={"snackbar"}
                autoHideDuration={3500}
            >
                <Alert 
                    onClose={handleClose} 
                    severity={snackbarVariant}
                    variant="filled"
                    sx={{ width: '100%' }}
                >
                        {snackbarMessage}
                </Alert>
            </Snackbar>
            {showRegistro ? 
                <FormRegistro 
                    showRegistro={showRegistro}
                    setShowRegistro={setShowRegistro}
                    showLogin={showLogin}
                    setShowLogin={setShowLogin}
                    setScope={setScope}
                    snackbarMessage={snackbarMessage}
                    setSnackbarMessage={setSnackbarMessage}
                    snackbarVariant={snackbarVariant}
                    setSnackbarVariant={setSnackbarVariant}
                    openSnackbar={openSnackbar}
                    setOpenSnackbar={setOpenSnackbar}
                    setShowForgot={setShowForgot}
                />
            : ""}
            {showLogin ?
                <FormLogin 
                    showRegistro={showRegistro}
                    setShowRegistro={setShowRegistro}
                    showLogin={showLogin}
                    setShowLogin={setShowLogin}
                    setScope={setScope}
                    trigger={trigger}
                    snackbarMessage={snackbarMessage}
                    setSnackbarMessage={setSnackbarMessage}
                    snackbarVariant={snackbarVariant}
                    setSnackbarVariant={setSnackbarVariant}
                    openSnackbar={openSnackbar}
                    setOpenSnackbar={setOpenSnackbar}
                    setShowForgot={setShowForgot}
                />
            : ""}
            {showForgot ?
                <FormForgot 
                    showRegistro={showRegistro}
                    setShowRegistro={setShowRegistro}
                    showLogin={showLogin}
                    setShowLogin={setShowLogin}
                    setScope={setScope}
                    trigger={trigger}
                    snackbarMessage={snackbarMessage}
                    setSnackbarMessage={setSnackbarMessage}
                    snackbarVariant={snackbarVariant}
                    setSnackbarVariant={setSnackbarVariant}
                    openSnackbar={openSnackbar}
                    setOpenSnackbar={setOpenSnackbar}
                    setShowForgot={setShowForgot}
                />
            : ""}
            {showRecovery ?
                <FormRecovery
                    showRegistro={showRecovery}
                    setShowRegistro={setShowRegistro}
                    showLogin={showLogin}
                    setShowLogin={setShowLogin}
                    showRecovery={showRecovery}
                    setShowRecovery={setShowRecovery}
                    setScope={setScope}
                    trigger={trigger}
                    snackbarMessage={snackbarMessage}
                    setSnackbarMessage={setSnackbarMessage}
                    snackbarVariant={snackbarVariant}
                    setSnackbarVariant={setSnackbarVariant}
                    openSnackbar={openSnackbar}
                    setOpenSnackbar={setOpenSnackbar}
                    setShowForgot={setShowForgot}
                />
            : ""}
        </WrapperStyled>
    );
};

export default BoxIngreso;